import { Dialog, DialogContainer, DialogDescription, DialogHeader, DialogTitle } from "@/shared/components";
import { RadixBaseUiInteropContextProvider } from "@/shared/components/utils/radix-base-ui-interop-provider.tsx";
import { useRef } from "react";
import { NewDossierForm } from "./new-dossier-form";

interface NewDossierDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    preselectedOgNummer?: string;
}

export function NewDossierDialog({ open, onOpenChange, preselectedOgNummer }: Readonly<NewDossierDialogProps>) {
    const dialogRef = useRef<HTMLDivElement | null>(null);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <RadixBaseUiInteropContextProvider radixElement={dialogRef}>
                <DialogContainer className="min-h-[168px]" ref={dialogRef}>
                    <DialogHeader>
                        <DialogTitle>Nieuw dossier</DialogTitle>
                        <DialogDescription className="sr-only">Nieuw dossier toevoegen</DialogDescription>
                    </DialogHeader>
                    <NewDossierForm onOpenChange={onOpenChange} preselectedOgNummer={preselectedOgNummer} />
                </DialogContainer>
            </RadixBaseUiInteropContextProvider>
        </Dialog>
    );
}
